/**
 * Common enums used across the application
 */

/**
 * TOC View Types - represents the current view in Table of Contents
 */
export type TOCViewType = 'active' | 'inactive';

/**
 * Enum for different data model types that support row highlighting
 */
export enum HighlightingModelType {
  TOC = 'TOC',
  ScenarioManagement = 'ScenarioManagement',
}

export enum TemplateType {
  SINGLE = 'single',
  GRANULAR = 'granular',
}
